import {InMemoryScrollingFeature, InMemoryScrollingOptions, Routes, withInMemoryScrolling} from '@angular/router';
import {ProjectListComponent} from './modules/project/components/project-list/project-list.component';
import {ProjectDetailComponent} from './modules/project/components/project-detail/project-detail.component';
import {ScreeningListComponent} from './modules/research/components/screening-list/screening-list.component';
import {PaperChatWindowComponent} from './modules/chat/components/paper-chat-window/paper-chat-window.component';
import {projectDetailResolver, projectListResolver} from './modules/project/service/project.resolver';
import {
  ProjectDetailWrapperComponent
} from './modules/project/components/project-detail-wrapper/project-detail-wrapper.component';
import {IntroductionComponent} from './modules/base/components/introduction/introduction.component';
import {
  ResearchPaperScreeningFlowComponent
} from './modules/research/components/research-paper-screening-flow/research-paper-screening-flow.component';
import {
  PaperEmbeddingAugmentorSearchComponent
} from './modules/chat/components/paper-embedding-augmentor-search/paper-embedding-augmentor-search.component';
import {
  PaperEmbeddingListComponent
} from './modules/chat/components/paper-embedding-list/paper-embedding-list.component';
import {
  IntroductionHowToComponent
} from './modules/documentation/components/introduction-how-to/introduction-how-to.component';
import {SummaryWindowComponent} from './modules/summary/components/summary-window/summary-window.component';
import {SummaryOverviewComponent} from './modules/summary/components/summary-overview/summary-overview.component';
import {
  IntroductionChangelogComponent
} from './modules/documentation/components/introduction-changelog/introduction-changelog.component';
import {
  IntroductionHelpComponent
} from './modules/documentation/components/introduction-help/introduction-help.component';
import {CookiePolicyComponent} from './modules/base/components/cookie-policy/cookie-policy.component';
import {PrivacyPolicyComponent} from './modules/base/components/privacy-policy/privacy-policy.component';
import {TosComponent} from './modules/base/components/tos/tos.component';
import {
  DocumentationWrapperComponent
} from './modules/documentation/components/documentation-wrapper/documentation-wrapper.component';
import {ExploreComponent} from './modules/explore/components/explore/explore.component';
import {ScreeningMetricsComponent} from './modules/research/components/screening-metrics/screening-metrics.component';
import {
  ResearchPaperDetailComponent
} from './modules/research/components/research-paper-detail/research-paper-detail.component';
import {
  researchPaperDetailResolver,
  researchPaperListResolver
} from './modules/research/services/research-paper/research-paper.resolver';
import {summaryDetailResolver, summaryListResolver} from './modules/summary/services/summary/summary.resolver';
import {SearchSettingsComponent} from './modules/research/components/search/search-settings/search-settings.component';
import {screeningSettingsResolver} from './modules/research/services/screening-settings/screening-settings.resolver';
import {globalConfigResolver} from './modules/global-config/global-config.resolver';

export const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
};

export const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

export const routes: Routes = [
  {
    path: '',
    component: IntroductionComponent,
    pathMatch: 'full',
    resolve: {globalConfig: globalConfigResolver},
  },
  {
    path: 'tos',
    component: TosComponent
  },
  {
    path: 'cookie',
    component: CookiePolicyComponent
  },
  {
    path: 'privacy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'introduction',
    redirectTo: '/',
  },
  {
    path: 'documentation',
    component: DocumentationWrapperComponent,
    children: [
      {
        path: '',
        component: IntroductionHowToComponent,
      },
      {
        path: 'how-to',
        component: IntroductionHowToComponent,
      },
      {
        path: 'changelog',
        component: IntroductionChangelogComponent,
      },
      {
        path: 'help',
        component: IntroductionHelpComponent,
      },
    ],
  },
  {
    path: 'explore',
    component: ExploreComponent,
  },
  {
    path: 'project',
    data: {breadcrumb: 'Projects'},
    resolve: {globalConfig: globalConfigResolver},
    children: [
      {
        path: '',
        component: ProjectListComponent,
        pathMatch: 'full',
        resolve: {
          projectList: projectListResolver
        },
      },
      {
        path: ':projectId',
        data: {
          animation: 'OverviewPage',
        },
        component: ProjectDetailWrapperComponent,
        resolve: {
          projectName: projectDetailResolver
        },
        runGuardsAndResolvers: 'pathParamsChange',
        children: [
          {
            path: '',
            redirectTo: 'setting',
            pathMatch: 'full',
          },
          {
            path: 'setting',
            component: ProjectDetailComponent,
            data: {breadcrumb: 'Settings'},
          },
          {
            path: 'search-setting',
            component: SearchSettingsComponent,
            resolve: {
              searchSettings: screeningSettingsResolver
            },
            runGuardsAndResolvers: 'pathParamsChange',
          },
          {
            path: 'paper/:paperId',
            component: ResearchPaperDetailComponent,
            resolve: {
              paperData: researchPaperDetailResolver
            },
            runGuardsAndResolvers: 'pathParamsChange',
            data: {breadcrumb: 'Settings', animation: 'DetailPage'},
          },
          {
            path: 'screening',
            data: {breadcrumb: 'Screenings'},
            children: [
              {
                path: '',
                component: ScreeningListComponent,
                data: {breadcrumb: 'Screenings', reuseKey: 'papers'},
                resolve: {
                  paperList: researchPaperListResolver
                },
                runGuardsAndResolvers: 'pathParamsChange',
              },
              {
                path: 'flow',
                component: ResearchPaperScreeningFlowComponent,
                resolve: {
                  paperList: researchPaperListResolver
                },
                data: {breadcrumb: 'flow'},
              },
              {
                path: 'eval',
                component: ScreeningMetricsComponent,
                resolve: {
                  paperList: researchPaperListResolver
                },
                data: {breadcrumb: 'Eval'},
              },
            ],
          },
          {
            path: 'analysis',
            data: {breadcrumb: 'Analysis'},
            children: [
              {
                path: '',
                component: SummaryOverviewComponent,
                resolve: {
                  summaryList: summaryListResolver
                },
                runGuardsAndResolvers: 'pathParamsChange',
              },
              {
                path: ':summaryId',
                component: SummaryWindowComponent,
                resolve: {
                  summaryDetail: summaryDetailResolver
                },
                runGuardsAndResolvers: 'pathParamsChange',
              }
            ]
          },
          {
            path: 'chat',
            data: {breadcrumb: 'Chat'},
            children: [
              {
                path: '',
                component: PaperChatWindowComponent,
              },
              {
                path: 'augmentor',
                component: PaperEmbeddingAugmentorSearchComponent,
                data: {breadcrumb: 'Augmentor'},
              },
              {
                path: 'embedding',
                component: PaperEmbeddingListComponent,
                data: {breadcrumb: 'Embedding'},
              }
            ],
          },
        ],
      },
    ],
  },
];
